import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import IconClose from "app/pages/.shared/IconClose";
import "./ProductFilterChip.scss";

const ProductFilterChip = ({ label, onRemove }) => {
	if (!label) {
		return null;
	}

	return (
		<div className="product-filter-chip">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.REGULAR}
				component="span"
				className="product-filter-chip__label"
			>
				{label}
			</Typography>

			<Button
				className="product-filter-chip__remove-button"
				variant={BUTTON_VARIANTS.BORDERLESS}
				onClick={onRemove}
				icon={<IconClose />}
			/>
		</div>
	);
};

ProductFilterChip.propTypes = {
	label: PropTypes.string.isRequired,
	onRemove: PropTypes.func.isRequired,
};

export default ProductFilterChip;
